module.exports = __webpack_public_path__ + "img/retro_sec3.1a25bd57.jpg";